import { render, staticRenderFns } from "./purchaseUDIscanCode.vue?vue&type=template&id=971cbf5e&scoped=true"
import script from "./purchaseUDIscanCode.vue?vue&type=script&lang=js"
export * from "./purchaseUDIscanCode.vue?vue&type=script&lang=js"
import style0 from "./purchaseUDIscanCode.vue?vue&type=style&index=0&id=971cbf5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971cbf5e",
  null
  
)

export default component.exports